import { useSelector } from "react-redux";
import { TModalsState } from "../../api/store/commonSlice";

type MenuItemLabelProps = {
  label: string;
};

const MenuItemLabel: React.FC<MenuItemLabelProps> = ({ label }) => {
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);

  if (modalsState?.showAdminsDropdown
    || modalsState?.showNotifications
    || modalsState?.showAlertNotifications
    || true) { // (11/4/2024 7:10pm) disabled per client feedback - they don't like labels
    return null
  }

  return (
    <span className="absolute text-[8px] uppercase top-full left-1/2 -translate-x-1/2 X-translate-y-1/2">{label}</span>
  );
}
export default MenuItemLabel;